// extracted by mini-css-extract-plugin
export default {"formModalHeader":"FormModal_formModalHeader__7Of6x","formModalContent":"FormModal_formModalContent__T5LDY","formModalFooter":"FormModal_formModalFooter__1GZhK"};